const type = 'SET_CURRENT_ROUTE';

const setCurrentRoute = (data) => ({
  data,
  type,
});

export default setCurrentRoute;
